/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createServerRootRoute } from '@tanstack/react-start/server'

import { Route as rootRouteImport } from './routes/__root'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppOverviewRouteImport } from './routes/app/overview'
import { Route as AppChatRouteImport } from './routes/app/chat'
import { Route as AppSrsCardsIndexRouteImport } from './routes/app/srs-cards/index'
import { Route as AppSettingsIndexRouteImport } from './routes/app/settings/index'
import { Route as AppLearnIndexRouteImport } from './routes/app/learn/index'
import { Route as AppDictionaryIndexRouteImport } from './routes/app/dictionary/index'
import { Route as AppSettingsProfileRouteImport } from './routes/app/settings/profile'
import { Route as AppSettingsParametersRouteImport } from './routes/app/settings/parameters'
import { Route as AppSettingsAiPreferencesRouteImport } from './routes/app/settings/ai-preferences'
import { Route as AppLearnReviewIndexRouteImport } from './routes/app/learn/review/index'
import { Route as AppLearnJlptLevelIndexRouteImport } from './routes/app/learn/jlpt/$level/index'
import { Route as AppLearnJlptLevelQuizIndexRouteImport } from './routes/app/learn/jlpt/$level/quiz/index'
import { Route as AppLearnJlptLevelVocabularyVocabIdRouteImport } from './routes/app/learn/jlpt/$level/vocabulary/$vocabId'
import { Route as AppLearnJlptLevelKanjiKanjiIdRouteImport } from './routes/app/learn/jlpt/$level/kanji/$kanjiId'
import { Route as AppLearnJlptLevelGrammarGrammarIdRouteImport } from './routes/app/learn/jlpt/$level/grammar/$grammarId'
import { ServerRoute as ApiChatIndexServerRouteImport } from './routes/api/chat/index'
import { ServerRoute as ApiChatEphemeralServerRouteImport } from './routes/api/chat/ephemeral'
import { ServerRoute as ApiAuthSplatServerRouteImport } from './routes/api/auth/$'

const rootServerRouteImport = createServerRootRoute()

const MaintenanceRoute = MaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppOverviewRoute = AppOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppRoute,
} as any)
const AppChatRoute = AppChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppSrsCardsIndexRoute = AppSrsCardsIndexRouteImport.update({
  id: '/srs-cards/',
  path: '/srs-cards/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppLearnIndexRoute = AppLearnIndexRouteImport.update({
  id: '/learn/',
  path: '/learn/',
  getParentRoute: () => AppRoute,
} as any)
const AppDictionaryIndexRoute = AppDictionaryIndexRouteImport.update({
  id: '/dictionary/',
  path: '/dictionary/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsParametersRoute = AppSettingsParametersRouteImport.update({
  id: '/parameters',
  path: '/parameters',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAiPreferencesRoute =
  AppSettingsAiPreferencesRouteImport.update({
    id: '/ai-preferences',
    path: '/ai-preferences',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppLearnReviewIndexRoute = AppLearnReviewIndexRouteImport.update({
  id: '/learn/review/',
  path: '/learn/review/',
  getParentRoute: () => AppRoute,
} as any)
const AppLearnJlptLevelIndexRoute = AppLearnJlptLevelIndexRouteImport.update({
  id: '/learn/jlpt/$level/',
  path: '/learn/jlpt/$level/',
  getParentRoute: () => AppRoute,
} as any)
const AppLearnJlptLevelQuizIndexRoute =
  AppLearnJlptLevelQuizIndexRouteImport.update({
    id: '/learn/jlpt/$level/quiz/',
    path: '/learn/jlpt/$level/quiz/',
    getParentRoute: () => AppRoute,
  } as any)
const AppLearnJlptLevelVocabularyVocabIdRoute =
  AppLearnJlptLevelVocabularyVocabIdRouteImport.update({
    id: '/learn/jlpt/$level/vocabulary/$vocabId',
    path: '/learn/jlpt/$level/vocabulary/$vocabId',
    getParentRoute: () => AppRoute,
  } as any)
const AppLearnJlptLevelKanjiKanjiIdRoute =
  AppLearnJlptLevelKanjiKanjiIdRouteImport.update({
    id: '/learn/jlpt/$level/kanji/$kanjiId',
    path: '/learn/jlpt/$level/kanji/$kanjiId',
    getParentRoute: () => AppRoute,
  } as any)
const AppLearnJlptLevelGrammarGrammarIdRoute =
  AppLearnJlptLevelGrammarGrammarIdRouteImport.update({
    id: '/learn/jlpt/$level/grammar/$grammarId',
    path: '/learn/jlpt/$level/grammar/$grammarId',
    getParentRoute: () => AppRoute,
  } as any)
const ApiChatIndexServerRoute = ApiChatIndexServerRouteImport.update({
  id: '/api/chat/',
  path: '/api/chat/',
  getParentRoute: () => rootServerRouteImport,
} as any)
const ApiChatEphemeralServerRoute = ApiChatEphemeralServerRouteImport.update({
  id: '/api/chat/ephemeral',
  path: '/api/chat/ephemeral',
  getParentRoute: () => rootServerRouteImport,
} as any)
const ApiAuthSplatServerRoute = ApiAuthSplatServerRouteImport.update({
  id: '/api/auth/$',
  path: '/api/auth/$',
  getParentRoute: () => rootServerRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/maintenance': typeof MaintenanceRoute
  '/app/chat': typeof AppChatRoute
  '/app/overview': typeof AppOverviewRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/app/settings/ai-preferences': typeof AppSettingsAiPreferencesRoute
  '/app/settings/parameters': typeof AppSettingsParametersRoute
  '/app/settings/profile': typeof AppSettingsProfileRoute
  '/app/dictionary': typeof AppDictionaryIndexRoute
  '/app/learn': typeof AppLearnIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/srs-cards': typeof AppSrsCardsIndexRoute
  '/app/learn/review': typeof AppLearnReviewIndexRoute
  '/app/learn/jlpt/$level': typeof AppLearnJlptLevelIndexRoute
  '/app/learn/jlpt/$level/grammar/$grammarId': typeof AppLearnJlptLevelGrammarGrammarIdRoute
  '/app/learn/jlpt/$level/kanji/$kanjiId': typeof AppLearnJlptLevelKanjiKanjiIdRoute
  '/app/learn/jlpt/$level/vocabulary/$vocabId': typeof AppLearnJlptLevelVocabularyVocabIdRoute
  '/app/learn/jlpt/$level/quiz': typeof AppLearnJlptLevelQuizIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/maintenance': typeof MaintenanceRoute
  '/app/chat': typeof AppChatRoute
  '/app/overview': typeof AppOverviewRoute
  '/app': typeof AppIndexRoute
  '/app/settings/ai-preferences': typeof AppSettingsAiPreferencesRoute
  '/app/settings/parameters': typeof AppSettingsParametersRoute
  '/app/settings/profile': typeof AppSettingsProfileRoute
  '/app/dictionary': typeof AppDictionaryIndexRoute
  '/app/learn': typeof AppLearnIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/app/srs-cards': typeof AppSrsCardsIndexRoute
  '/app/learn/review': typeof AppLearnReviewIndexRoute
  '/app/learn/jlpt/$level': typeof AppLearnJlptLevelIndexRoute
  '/app/learn/jlpt/$level/grammar/$grammarId': typeof AppLearnJlptLevelGrammarGrammarIdRoute
  '/app/learn/jlpt/$level/kanji/$kanjiId': typeof AppLearnJlptLevelKanjiKanjiIdRoute
  '/app/learn/jlpt/$level/vocabulary/$vocabId': typeof AppLearnJlptLevelVocabularyVocabIdRoute
  '/app/learn/jlpt/$level/quiz': typeof AppLearnJlptLevelQuizIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/maintenance': typeof MaintenanceRoute
  '/app/chat': typeof AppChatRoute
  '/app/overview': typeof AppOverviewRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/app/settings/ai-preferences': typeof AppSettingsAiPreferencesRoute
  '/app/settings/parameters': typeof AppSettingsParametersRoute
  '/app/settings/profile': typeof AppSettingsProfileRoute
  '/app/dictionary/': typeof AppDictionaryIndexRoute
  '/app/learn/': typeof AppLearnIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/srs-cards/': typeof AppSrsCardsIndexRoute
  '/app/learn/review/': typeof AppLearnReviewIndexRoute
  '/app/learn/jlpt/$level/': typeof AppLearnJlptLevelIndexRoute
  '/app/learn/jlpt/$level/grammar/$grammarId': typeof AppLearnJlptLevelGrammarGrammarIdRoute
  '/app/learn/jlpt/$level/kanji/$kanjiId': typeof AppLearnJlptLevelKanjiKanjiIdRoute
  '/app/learn/jlpt/$level/vocabulary/$vocabId': typeof AppLearnJlptLevelVocabularyVocabIdRoute
  '/app/learn/jlpt/$level/quiz/': typeof AppLearnJlptLevelQuizIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/maintenance'
    | '/app/chat'
    | '/app/overview'
    | '/app/settings'
    | '/app/'
    | '/app/settings/ai-preferences'
    | '/app/settings/parameters'
    | '/app/settings/profile'
    | '/app/dictionary'
    | '/app/learn'
    | '/app/settings/'
    | '/app/srs-cards'
    | '/app/learn/review'
    | '/app/learn/jlpt/$level'
    | '/app/learn/jlpt/$level/grammar/$grammarId'
    | '/app/learn/jlpt/$level/kanji/$kanjiId'
    | '/app/learn/jlpt/$level/vocabulary/$vocabId'
    | '/app/learn/jlpt/$level/quiz'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/maintenance'
    | '/app/chat'
    | '/app/overview'
    | '/app'
    | '/app/settings/ai-preferences'
    | '/app/settings/parameters'
    | '/app/settings/profile'
    | '/app/dictionary'
    | '/app/learn'
    | '/app/settings'
    | '/app/srs-cards'
    | '/app/learn/review'
    | '/app/learn/jlpt/$level'
    | '/app/learn/jlpt/$level/grammar/$grammarId'
    | '/app/learn/jlpt/$level/kanji/$kanjiId'
    | '/app/learn/jlpt/$level/vocabulary/$vocabId'
    | '/app/learn/jlpt/$level/quiz'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/maintenance'
    | '/app/chat'
    | '/app/overview'
    | '/app/settings'
    | '/app/'
    | '/app/settings/ai-preferences'
    | '/app/settings/parameters'
    | '/app/settings/profile'
    | '/app/dictionary/'
    | '/app/learn/'
    | '/app/settings/'
    | '/app/srs-cards/'
    | '/app/learn/review/'
    | '/app/learn/jlpt/$level/'
    | '/app/learn/jlpt/$level/grammar/$grammarId'
    | '/app/learn/jlpt/$level/kanji/$kanjiId'
    | '/app/learn/jlpt/$level/vocabulary/$vocabId'
    | '/app/learn/jlpt/$level/quiz/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  MaintenanceRoute: typeof MaintenanceRoute
}
export interface FileServerRoutesByFullPath {
  '/api/auth/$': typeof ApiAuthSplatServerRoute
  '/api/chat/ephemeral': typeof ApiChatEphemeralServerRoute
  '/api/chat': typeof ApiChatIndexServerRoute
}
export interface FileServerRoutesByTo {
  '/api/auth/$': typeof ApiAuthSplatServerRoute
  '/api/chat/ephemeral': typeof ApiChatEphemeralServerRoute
  '/api/chat': typeof ApiChatIndexServerRoute
}
export interface FileServerRoutesById {
  __root__: typeof rootServerRouteImport
  '/api/auth/$': typeof ApiAuthSplatServerRoute
  '/api/chat/ephemeral': typeof ApiChatEphemeralServerRoute
  '/api/chat/': typeof ApiChatIndexServerRoute
}
export interface FileServerRouteTypes {
  fileServerRoutesByFullPath: FileServerRoutesByFullPath
  fullPaths: '/api/auth/$' | '/api/chat/ephemeral' | '/api/chat'
  fileServerRoutesByTo: FileServerRoutesByTo
  to: '/api/auth/$' | '/api/chat/ephemeral' | '/api/chat'
  id: '__root__' | '/api/auth/$' | '/api/chat/ephemeral' | '/api/chat/'
  fileServerRoutesById: FileServerRoutesById
}
export interface RootServerRouteChildren {
  ApiAuthSplatServerRoute: typeof ApiAuthSplatServerRoute
  ApiChatEphemeralServerRoute: typeof ApiChatEphemeralServerRoute
  ApiChatIndexServerRoute: typeof ApiChatIndexServerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/overview': {
      id: '/app/overview'
      path: '/overview'
      fullPath: '/app/overview'
      preLoaderRoute: typeof AppOverviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/chat': {
      id: '/app/chat'
      path: '/chat'
      fullPath: '/app/chat'
      preLoaderRoute: typeof AppChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/srs-cards/': {
      id: '/app/srs-cards/'
      path: '/srs-cards'
      fullPath: '/app/srs-cards'
      preLoaderRoute: typeof AppSrsCardsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/learn/': {
      id: '/app/learn/'
      path: '/learn'
      fullPath: '/app/learn'
      preLoaderRoute: typeof AppLearnIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dictionary/': {
      id: '/app/dictionary/'
      path: '/dictionary'
      fullPath: '/app/dictionary'
      preLoaderRoute: typeof AppDictionaryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/profile': {
      id: '/app/settings/profile'
      path: '/profile'
      fullPath: '/app/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/parameters': {
      id: '/app/settings/parameters'
      path: '/parameters'
      fullPath: '/app/settings/parameters'
      preLoaderRoute: typeof AppSettingsParametersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/ai-preferences': {
      id: '/app/settings/ai-preferences'
      path: '/ai-preferences'
      fullPath: '/app/settings/ai-preferences'
      preLoaderRoute: typeof AppSettingsAiPreferencesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/learn/review/': {
      id: '/app/learn/review/'
      path: '/learn/review'
      fullPath: '/app/learn/review'
      preLoaderRoute: typeof AppLearnReviewIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/learn/jlpt/$level/': {
      id: '/app/learn/jlpt/$level/'
      path: '/learn/jlpt/$level'
      fullPath: '/app/learn/jlpt/$level'
      preLoaderRoute: typeof AppLearnJlptLevelIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/learn/jlpt/$level/quiz/': {
      id: '/app/learn/jlpt/$level/quiz/'
      path: '/learn/jlpt/$level/quiz'
      fullPath: '/app/learn/jlpt/$level/quiz'
      preLoaderRoute: typeof AppLearnJlptLevelQuizIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/learn/jlpt/$level/vocabulary/$vocabId': {
      id: '/app/learn/jlpt/$level/vocabulary/$vocabId'
      path: '/learn/jlpt/$level/vocabulary/$vocabId'
      fullPath: '/app/learn/jlpt/$level/vocabulary/$vocabId'
      preLoaderRoute: typeof AppLearnJlptLevelVocabularyVocabIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/learn/jlpt/$level/kanji/$kanjiId': {
      id: '/app/learn/jlpt/$level/kanji/$kanjiId'
      path: '/learn/jlpt/$level/kanji/$kanjiId'
      fullPath: '/app/learn/jlpt/$level/kanji/$kanjiId'
      preLoaderRoute: typeof AppLearnJlptLevelKanjiKanjiIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/learn/jlpt/$level/grammar/$grammarId': {
      id: '/app/learn/jlpt/$level/grammar/$grammarId'
      path: '/learn/jlpt/$level/grammar/$grammarId'
      fullPath: '/app/learn/jlpt/$level/grammar/$grammarId'
      preLoaderRoute: typeof AppLearnJlptLevelGrammarGrammarIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}
declare module '@tanstack/react-start/server' {
  interface ServerFileRoutesByPath {
    '/api/chat/': {
      id: '/api/chat/'
      path: '/api/chat'
      fullPath: '/api/chat'
      preLoaderRoute: typeof ApiChatIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/chat/ephemeral': {
      id: '/api/chat/ephemeral'
      path: '/api/chat/ephemeral'
      fullPath: '/api/chat/ephemeral'
      preLoaderRoute: typeof ApiChatEphemeralServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/auth/$': {
      id: '/api/auth/$'
      path: '/api/auth/$'
      fullPath: '/api/auth/$'
      preLoaderRoute: typeof ApiAuthSplatServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsAiPreferencesRoute: typeof AppSettingsAiPreferencesRoute
  AppSettingsParametersRoute: typeof AppSettingsParametersRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAiPreferencesRoute: AppSettingsAiPreferencesRoute,
  AppSettingsParametersRoute: AppSettingsParametersRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppChatRoute: typeof AppChatRoute
  AppOverviewRoute: typeof AppOverviewRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppDictionaryIndexRoute: typeof AppDictionaryIndexRoute
  AppLearnIndexRoute: typeof AppLearnIndexRoute
  AppSrsCardsIndexRoute: typeof AppSrsCardsIndexRoute
  AppLearnReviewIndexRoute: typeof AppLearnReviewIndexRoute
  AppLearnJlptLevelIndexRoute: typeof AppLearnJlptLevelIndexRoute
  AppLearnJlptLevelGrammarGrammarIdRoute: typeof AppLearnJlptLevelGrammarGrammarIdRoute
  AppLearnJlptLevelKanjiKanjiIdRoute: typeof AppLearnJlptLevelKanjiKanjiIdRoute
  AppLearnJlptLevelVocabularyVocabIdRoute: typeof AppLearnJlptLevelVocabularyVocabIdRoute
  AppLearnJlptLevelQuizIndexRoute: typeof AppLearnJlptLevelQuizIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppChatRoute: AppChatRoute,
  AppOverviewRoute: AppOverviewRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppDictionaryIndexRoute: AppDictionaryIndexRoute,
  AppLearnIndexRoute: AppLearnIndexRoute,
  AppSrsCardsIndexRoute: AppSrsCardsIndexRoute,
  AppLearnReviewIndexRoute: AppLearnReviewIndexRoute,
  AppLearnJlptLevelIndexRoute: AppLearnJlptLevelIndexRoute,
  AppLearnJlptLevelGrammarGrammarIdRoute:
    AppLearnJlptLevelGrammarGrammarIdRoute,
  AppLearnJlptLevelKanjiKanjiIdRoute: AppLearnJlptLevelKanjiKanjiIdRoute,
  AppLearnJlptLevelVocabularyVocabIdRoute:
    AppLearnJlptLevelVocabularyVocabIdRoute,
  AppLearnJlptLevelQuizIndexRoute: AppLearnJlptLevelQuizIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  MaintenanceRoute: MaintenanceRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
const rootServerRouteChildren: RootServerRouteChildren = {
  ApiAuthSplatServerRoute: ApiAuthSplatServerRoute,
  ApiChatEphemeralServerRoute: ApiChatEphemeralServerRoute,
  ApiChatIndexServerRoute: ApiChatIndexServerRoute,
}
export const serverRouteTree = rootServerRouteImport
  ._addFileChildren(rootServerRouteChildren)
  ._addFileTypes<FileServerRouteTypes>()
